export const SHIPPING_COST_PAGE_NAME = "Shipping Cost"

export const SHIPPING_COST_PAGES = {
    TABLE: "table",
}

export const LIST_SHIPPING_COST_CELLS = [
    { id: 'packaging',label: 'Packaging'},
    { id: 'averageCost',label: 'Average Cost'},
    // { id: 'carrierName',label: 'Carrier'},
    { id: 'currency',label: 'Currency'}
];

export const CURRENCIES = [
    "USD",
    "CAD"
]
export const DEFAULT_SORT_BY_HEAD_CELL = 'packaging';
export const ROWS_PER_PAGE_LABEL = "Shipping Cost per page"
